const key = r => `${r.fromDraftId}|${r.toDraftId}|${r.relateType}`;
export const applyWorldRelationshipProposals = (relationships, proposals, existing, createId) => {
  const result = [...relationships];
  const known = new Map(existing.map(r => [key(r), r]));
  const seen = new Set();
  for (const proposal of proposals) {
    const id = key(proposal), prior = known.get(id), index = result.findIndex(r => key(r) === id);
    if (seen.has(id)) throw new Error('A relationship can be changed only once per pass.');
    seen.add(id);
    if (proposal.operation === 'set_score') {
      if (!prior || (prior.score ?? 50) !== proposal.expectedScore) throw new Error('Relationship changed since this proposal was prepared.');
      if (!proposal.eventDraftIds?.length || proposal.eventDraftIds.every(e => prior.eventDraftIds?.includes(e))) throw new Error('Relationship changes require new Event evidence.');
      const previous = index < 0 ? prior : result[index];
      const merged = { ...previous, ...proposal, draftRelationshipId: previous.draftRelationshipId || createId(),
        eventDraftIds: [...new Set([...(previous.eventDraftIds || []), ...proposal.eventDraftIds])],
        socialSeedIds: [...new Set([...(previous.socialSeedIds || []), ...(proposal.socialSeedIds || [])])],
        history: [...(previous.history || []), { score: previous.score ?? 50, reason: previous.reason || '',
          eventDraftIds: previous.eventDraftIds || [], socialSeedIds: previous.socialSeedIds || [], knownByEntityIds: previous.knownByEntityIds || [] }] };
      if (index < 0) result.push(merged); else result[index] = merged;
      known.set(id, merged);
    } else {
      if (prior) throw new Error('Do not duplicate an existing relationship.');
      const added = { ...proposal, draftRelationshipId: createId() };
      result.push(added); known.set(id, added);
    }
  }
  return result;
};
